<template>
  <!-- Button only shows if sportTitle is 'Squash' -->
  <!-- Re-Add to Squash when ready v-if="sportTitle?.toLowerCase() === 'squash'" -->
  <!-- v-if="false" to be used to hide switcher -->
  <v-btn v-if="sportTitle?.toLowerCase() === 'squash'" class="mr-md-5 mr-3 tech_language_button" icon size="26" :ripple="false">
    
    <!-- Current selected language flag -->
    <v-avatar :image="selectedFlag" size="26" />
    
    <!-- Dropdown menu for selecting a language -->
    <v-menu activator="parent" origin="top" scroll-strategy="block" offset="19">
      
      <!-- Language options list -->
      <v-list class="d-flex flex-column ga-0 pa-0" color="primary" base-color="primary" elevation="1">
        
        <!-- Each language item with flag and title -->
        <v-list-item
        v-for="(item, index) in items"
        :key="index"
        class="language_button_item px-3 py-2"
        @click="switchLanguage(item.lang)"
        >
        <v-avatar class="language_button_avatar" :image="item.prependAvatar" size="26" />
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</v-btn>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useUserDataStore } from '@/store/userDataStore'
import { sportTitle } from '@/services/admin_actions/apiUtils';

import flagUK from '@/assets/flags/Flag_of_United_Kingdom.svg'
import flagFR from '@/assets/flags/Flag_of_France.svg'
import flagAR from '@/assets/flags/Flag_of_Arab_League.svg'
import flagES from '@/assets/flags/Flag_of_Spain.svg'

// Access Vue Router
const router = useRouter()
const route = useRoute()

// Define available languages and their flags
const items = [
{
  lang: 'en',
  title: 'English',
  prependAvatar: flagUK,
},
{
  lang: 'ar',
  title: 'Arabic',
  prependAvatar: flagAR,
},
{
  lang: 'fr',
  title: 'French',
  prependAvatar: flagFR,
},
{
  lang: 'es',
  title: 'Spanish',
  prependAvatar: flagES,
},
]

// Holds the currently selected flag
const selectedFlag = ref(flagUK)

// Reactive admin access check
const userDataStore = useUserDataStore()
const isAdmin = computed(() => userDataStore.hasAccess(['is_admin']))

// On mount, detect current language from route or URL and update selected flag
onMounted(() => {
  const lang = route.params.lang || window.location.pathname.split('/')[1]
  const match = items.find(i => i.lang === lang)
  if (match) selectedFlag.value = match.prependAvatar
})

// Called when a new language is selected from the menu
// Updates the URL to switch languages - Includes Classic Pages
// const switchLanguage = (lang: string) => {
//   const selected = items.find(i => i.lang === lang)
//   if (selected) selectedFlag.value = selected.prependAvatar
  
//   const currentUrl = window.location.href
//   const pathParts = window.location.pathname.split('/').filter(Boolean)
//   if (['en', 'fr', 'ar', 'es'].includes(pathParts[0])) pathParts.shift()
  
//   const newPath = `/${lang}/${pathParts.join('/')}`
//   const fullPath = `${newPath}${window.location.search}${window.location.hash}`
  
//   // Log for debugging
//   console.groupCollapsed('[Language Switch]')
//   console.log('Current URL:', currentUrl)
//   console.log('Selected Language:', lang)
//   console.log('Navigating to:', fullPath)
//   console.groupEnd()
  
//   // Redirect to new language path
//   window.location.href = fullPath
// };

// Temporary switchLanguage function to always go to Search page
const switchLanguage = (lang: string) => {
  const selected = items.find(i => i.lang === lang)
  if (selected) selectedFlag.value = selected.prependAvatar

  const currentUrl = window.location.href
  const targetPath = `/${lang}/search${window.location.search}${window.location.hash}`

  console.groupCollapsed('[Language Switch]')
  console.log('Current URL:', currentUrl)
  console.log('Selected Language:', lang)
  console.log('Navigating to:', targetPath)
  console.groupEnd()

  // Redirect to Search page in selected language
  window.location.href = targetPath
};
</script>

<style lang="scss">

// Change language switcher positioning on mobile
@media (max-width: 767px) {
  .tech_language_button {
    position: fixed !important;
    bottom: 75px;
    right: 5px;
    z-index: 2000; // Ensure it appears above other elements
    
    .v-avatar {
      width: 36px !important;
      height: 36px !important;
    }
  }
  
  
  .language_button_avatar {
    width: 26px !important;
    height: 26px !important;
  }
}

// Syle the Language Switcher button items
.language_button_item {
  
  // Ensure content fills available space
  width: 100%;
  display: flex;
  
  // Ensure items are flex and aligned
  .v-list-item__content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 10px;
  }
}

</style>